<template>
  <pt-trust-deed-table class="pt-trust-deed-table__withData" ref="table" :selectType="selectType" :layout="layout" :pageSizes="pageSizes" :request-data="getDataList" :page-size="pageSize" :total-number="Number(totalNumber)" :table-data="tableData" :tableLabels="tableLabels" :isAddPageToRouter="!isDialog" v-on="$listeners" @size-change="handleSizeChange" :selectedKeys="selectedKeys" @selection-change="handleSelectionChange">
    <template slot="reportNum" slot-scope="scope">
         <slot :row="scope.row" name="reportNum"></slot>
    </template>
    <template slot="billStatusEnum" slot-scope="scope">
      <slot :row="scope.row" name="billStatusEnum"></slot>
    </template>
    <template slot-scope="scope">
      <slot :row="scope.row"></slot>
    </template>
  </pt-trust-deed-table>
</template>

<script>
import fillUrl from '@/mixins/fillUrl'
import PtTrustDeedTable from './index'
export default {
  name: 'pt-trust-deed-table__withData',
  components: {
    'pt-trust-deed-table': PtTrustDeedTable
  },
  mixins: [fillUrl],
  data () {
    return {
      pageSize: this.isDialog ? 5 : 10,
      totalNumber: 0,
      tableData: [],
      currentParams: this.params
    }
  },
  props: {
    tableLabels: {
      type: Array,
      default: () => []
    },
    params: {
      type: Object,
      default: () => {}
    },
    selectType: {
      type: String,
      default: 'checkbox'
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    // 传进的id // 用于回显
    selectedKeys: {
      type: String,
      default: ''
    },
    billStatusEnum:{
      type:String,
      default:null
    },
    isLot:Boolean
  },
  computed: {
    layout () {
      if (this.isDialog) {
        return 'total, prev, pager, next,jumper'
      }
      return 'sizes,total, prev, pager, next,jumper'
    },
    pageSizes () {
      if (this.isDialog) {
        return []
      }
      return [10, 25, 50, 100, 500, 1000, 2000]
    }
  },
  watch: {
    params (val) {
      this.currentParams = { ...val }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
    },
    filter (params) {
      this.currentParams = params
      for (let key in this.currentParams) {
        if (!this.currentParams[key]) {
          this.$delete(this.currentParams, key)
        }
      }
      !this.isDialog && this.fillUrl({ ...this.currentParams })
      this.$refs.table.resetPage()
    },
    buildParams (params) {
      const res = { ...params }
      res.settlement = res.settlement && Boolean(res.settlement === 'true')
      res.invoice = res.invoice && Boolean(res.invoice === 'true')
      res.back = res.back && Boolean(res.back === 'true')
      res.urgent = res.urgent && Boolean(res.urgent === 'true')
      res.deviate = res.deviate && Boolean(res.deviate === 'true')
      res.isCall = res.isCall && Boolean(res.isCall === 'true')
      res.overDue = res.overDue && Boolean(res.overDue === 'true')    
      if (params.organizationId) {
        res.organization = {
          id: params.organizationId
        }
        this.$delete(res, 'organizationId')
      }
      return res
    },
    getDataList (page, next) {
      const otherParams = this.buildParams(this.currentParams)
      let data = {
        example: {
          billStatusEnum:this.billStatusEnum,
          ...otherParams,
        },
        pageable: {
          page: page,
          size: this.pageSize
        }
      }
      const api = this.isLot ? 'getBatchBillList' :'getBillList'
      this.$store.dispatch(api, data).then(res => {
        next && next(res.data)
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.$emit('getAllSize', this.totalNumber)
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    },
    // 筛选数据的参数,不传默认为{}
    reload () {
      this.$refs.table.reload()
    },
    handleSelectionChange (val) {
      this.$emit('selection-change', val)
    }
  }
}
</script>
